import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { updateSurvey } from "./api";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { questions, jobs, ...otherValues } = values;

  const filteredValues = Object.fromEntries(
    Object.entries(otherValues).filter(
      ([_, v]) => v !== "" && v !== undefined && v !== null
    )
  );

  if (Array.isArray(jobs)) {
    filteredValues.jobs = jobs.map((job) => ({ job }));
  }
  if (Array.isArray(questions)) {
    filteredValues.questions = questions.map((question) => ({ question: question }));
  }

  return filteredValues;
}

export function useUpdateCsat() {
  return useMutation({
    mutationFn: async ({ item, surveyId }) => {
      const payload = buildPayload(item);
      const response = await updateSurvey({ item: payload, surveyId });
      return response;
    },
    onSuccess: () => {
      toast.success("Survey Updated Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
